import React from "react";
import PropTypes from "prop-types";
import { Button } from "cxa-components";
import { reduxForm } from "redux-form";
import HDFComponent from "./components/HDFComponent";
import { submitHdf } from "./actions";
import messages from "components/messagesDescription";
import { FormattedMessage } from 'react-intl';

const Form = ({ data, activePage = 1, setActivePage, invalid, handleSubmit, submitting, submitFailed, intl }) => {
  const pageData = data.config.pages[activePage - 1];
  const { components, component } = pageData;
  const isLastPage = activePage == data.config.pages.length;

  const goPrevious = () => {
    if (activePage > 0) {
      setActivePage(activePage - 1);
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    }
  };

  const goNext = () => {
    if (data.isCompleted && isLastPage) {
      window.close();
    } else {
      if (!data.isCompleted) {
        handleSubmit();
      }
      if (!invalid && activePage < data.config.pages.length) {
        setActivePage(activePage + 1);
        window.scrollTo({
          top: 0,
          behavior: "smooth",
        });
      }
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <div className="hdf-header">
        <strong>{pageData.pageName}</strong>
      </div>

      {component ? (
        <HDFComponent name={component.id} type={component.type} comp={component} />
      ) : (
        components &&
        components.length > 0 &&
        components.map(comp => {
          return <HDFComponent key={comp.id} name={comp.id} comp={comp} />;
        })
      )}

      {invalid && submitFailed &&(
        <p role="alert" className="card--alert">
           <FormattedMessage {...messages.GENHDF_SUBMIT_FAILURE_MESSAGE} />
        </p>
      )}
      <div
        className="btn-container"
        style={{
          justifyContent: "flex-end",
        }}
      >
        {activePage > 1 && (
          <Button className="enrolment-btn" secondary type="button" onClick={goPrevious}>
            Previous
          </Button>
        )}
        <Button
          primary
          className="enrolment-btn"
          type="button"
          disabled={submitting}
          onClick={goNext}
        >
          {data.isCompleted && isLastPage ? "Close" : isLastPage ? "Submit & Confirm" : "Next"}
        </Button>
      </div>
    </form>
  );
};

Form.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  submitting: PropTypes.bool.isRequired,
  invalid: PropTypes.bool.isRequired,
  submitFailed: PropTypes.bool.isRequired,
  data: PropTypes.object,
  activePage: PropTypes.number,
  setActivePage: PropTypes.func.isRequired,
  intl: PropTypes.shape({
    formatMessage: PropTypes.func.isRequired
  }).isRequired
};

export default reduxForm({
  form: "GeneralHDF",
  onSubmit: submitHdf,
  enableReinitialize: true,
})(Form);



// WEBPACK FOOTER //
// ./components/employee/gen-hdf-form/Form.js